import { controls } from "../../controls";

const rp114 = {
  label: "Customer KYC Compliance",
  starting: true,
  url: "rp114",
  pageLabel: "Customer KYC Compliance",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),


    ...controls.displayText({ tab: "filter", label: "GL Sub Head" }),
    ...controls.GL({ tab: "filter" }),
    ...controls.showData({
      tab: "filter", data: "gl_code_display"
    }),

    ...controls.magicDateLabel({ label: "From Date", target: "from_date" }),
    ...controls.magicDate({ dateType: "ontype", default: "y", isRequired: true, name: "from_date", width: "col-sm-2" }),

    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),

    ...controls.magicDateLabel({ label: "To Date", target: "to_date" }),
    ...controls.magicDate({ dateType: "ontype", default: "n", isRequired: true, name: "to_date", width: "col-sm-2" }),

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Customer KYC Compliance",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    defaultsTo: 0,
    textReportProps: {
      '132': {
        header: [[{ source: 'history', field: 'reportHeader' }, { source: 'fixed', value: 'From Date' }, { field: 'from_date', type: 'date' }, { source: 'fixed', value: 'To Date' }, { field: 'to_date', type: 'date' }, { source: 'fixed', value: 'GL' }, { source: 'fixed', value: '-' }, { field: 'gl_code_display' }],
        [{ source: 'fixed', value: 'Parent Branch' }, { field: 'branch_code' }, { source: 'fixed', value: '-' }, { field: 'branch_display' }]],
        footer: "default"
      }
    },
    clickable: false,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      {
        Header: "CIN",
        accessor: "Customer-branch-branch_code",
        width: 200,
        rwidth: 70,
        width132: { size: 14 },
        // type:"date"
      },
      {
        Header: "Name",
        accessor: "Customer-institutional_details-full_name",
        rwidth: "*",
        width132: { size: 60 },
      },

      {
        Header: "Balance",
        columns: [
          {
            Header: "Deposit",
            accessor: "deposit_bal",
            rwidth: 70,
            width: 200,
            // type: "currency",
            width132: { size: 14 },
          },
          {
            Header: "Loan",
            accessor: "loan_bal",
            rwidth: 70,
            width: 200,
            // type: "currency",
            width132: { size: 14 },
          },
        ]
      },
      {
        Header: "Risk Category",
        accessor: "Customer-individual_details-dob",
        rwidth: 70,
        width: 200,
        width132: { size: 18 },
      },
      {
        Header: "Last KYC Date",
        accessor: "last_kyc_date",
        rwidth: 70,
        width: 200,
        type: "date",
        width132: { size: 22, comma: true },
      },
    ]
  }
};

export default rp114;